import React, { useState, useEffect } from "react";
import "../styles/dakvent.scss";


const Dakventilatie = () => {
  const [open, setOpen] = useState(null);
  const toggle = (i) => setOpen(open === i ? null : i);

  useEffect(() => {
    document.title = 'Dakventilatie - Fresh Air Care';
  }, []);

    return (
    <div className="dk-page">
      {/* ========== HERO ========== */}
      <section className="dk-hero">
        <div className="dk-container">
          <div className="dk-hero-content">
            <div className="dk-badge">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L13.09 8.26L19 7L14.74 12L19 17L13.09 15.74L12 22L10.91 15.74L5 17L9.26 12L5 7L10.91 8.26L12 2Z" fill="currentColor"/>
              </svg>
              Dakventilatie
            </div>
            <h1 className="dk-hero-title">
              Vochtproblemen oplossen, <span className="dk-accent">dak gezond houden</span>
            </h1>
            <p className="dk-hero-description">
              Professionele dakventilatie en kanalen voor optimale vochtbeheersing en doorstroom.
            </p>
            <div className="dk-cta-row">
              <a href="#contact" className="cta-primary1" onClick={() => window.location.href = '#contact'}>
                Gratis Inspectie
              </a>
              <a href="/tarieven" className="cta-secondary1" onClick={() => window.location.href = '/tarieven'}>
                Bekijk Tarieven
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ========== ROOF PROBLEMS ========== */}
      <section className="dk-section dk-roof-problems">
        <div className="dk-container">
          <div className="dk-section-header">
            <h2 className="dk-section-title">Veelvoorkomende dakproblemen</h2>
            <p className="dk-section-description">
              Herken de signalen en voorkom dure reparaties
            </p>
          </div>
          
          <div className="dk-problems-timeline">
            <div className="dk-timeline-step">
              <div className="dk-step-number">1</div>
              <div className="dk-step-content">
                <h3>Vochtophoping</h3>
                <p>Condensatie tussen isolatie en dakbedekking door gebrek aan ventilatie</p>
                <div className="dk-problem-signs">
                  <span className="dk-sign">• Vochtplekken op plafond</span>
                  <span className="dk-sign">• Druppels aan balken</span>
                  <span className="dk-sign">• Vochtige isolatie</span>
                </div>
              </div>
            </div>
            
            <div className="dk-timeline-step">
              <div className="dk-step-number">2</div>
              <div className="dk-step-content">
                <h3>Schimmelvorming</h3>
                <p>Schimmel en bacteriën gedijen in vochtige omstandigheden</p>
                <div className="dk-problem-signs">
                  <span className="dk-sign">• Zwarte vlekken</span>
                  <span className="dk-sign">• Muffe geur</span>
                  <span className="dk-sign">• Gezondheidsklachten</span>
                </div>
              </div>
            </div>
            
            <div className="dk-timeline-step">
              <div className="dk-step-number">3</div>
              <div className="dk-step-content">
                <h3>Dakschade</h3>
                <p>Vochtige isolatie verliest werking, dakbedekking gaat lekken</p>
                <div className="dk-problem-signs">
                  <span className="dk-sign">• Lekkages</span>
                  <span className="dk-sign">• Hoge energiekosten</span>
                  <span className="dk-sign">• Vervanging nodig</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ========== VENTILATION SOLUTIONS ========== */}
      <section className="dk-section dk-section-dark" id="oplossingen">
        <div className="dk-container">
          <div className="dk-section-header">
            <h2 className="dk-section-title">Ventilatie oplossingen</h2>
            <p className="dk-section-description">
              Kies de juiste ventilatie voor jouw daktype en situatie
            </p>
          </div>

          <div className="dk-solutions-grid">
            <div className="dk-solution-card">
              <div className="dk-solution-image">
                <div className="dk-solution-placeholder">
                  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L13.09 8.26L19 7L14.74 12L19 17L13.09 15.74L12 22L10.91 15.74L5 17L9.26 12L5 7L10.91 8.26L12 2Z" fill="currentColor"/>
                  </svg>
                </div>
              </div>
              <div className="dk-solution-content">
                <h3>Nokventilatie</h3>
                <p>Onzichtbare ventilatie langs de daknok voor optimale luchtcirculatie</p>
                <div className="dk-solution-features">
                  <div className="dk-feature-item">✓ Onzichtbaar</div>
                  <div className="dk-feature-item">✓ Alle daktypes</div>
                  <div className="dk-feature-item">✓ €150-200/m</div>
                </div>
              </div>
            </div>
            
            <div className="dk-solution-card dk-solution-featured">
              <div className="dk-solution-image">
                <div className="dk-solution-placeholder">
                  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" fill="currentColor"/>
                  </svg>
                </div>
              </div>
              <div className="dk-solution-content">
                <h3>Dakdoorvoeren</h3>
                <p>Maximale ventilatie door dakdoorvoeren voor platte en hellende daken</p>
                <div className="dk-solution-features">
                  <div className="dk-feature-item">✓ Maximale doorstroom</div>
                  <div className="dk-feature-item">✓ Weerbestendig</div>
                  <div className="dk-feature-item">✓ €200-300/stuk</div>
                </div>
              </div>
            </div>
            
            <div className="dk-solution-card">
              <div className="dk-solution-image">
                <div className="dk-solution-placeholder">
                  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" fill="currentColor"/>
                  </svg>
                </div>
              </div>
              <div className="dk-solution-content">
                <h3>Dakrandventilatie</h3>
                <p>Traditionele ventilatie langs dakranden voor klassieke daken</p>
                <div className="dk-solution-features">
                  <div className="dk-feature-item">✓ Traditioneel</div>
                  <div className="dk-feature-item">✓ Zichtbaar</div>
                  <div className="dk-feature-item">✓ €100-150/m</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ========== COMPARISON ========== */}
      <section className="dk-section dk-comparison">
        <div className="dk-container">
          <div className="dk-section-header">
            <h2 className="dk-section-title">Met of zonder dakventilatie?</h2>
            <p className="dk-section-description">
              Vergelijk de voordelen van professionele dakventilatie
            </p>
          </div>
          
          <div className="dk-comparison-grid">
            <div className="dk-comparison-card dk-traditional">
              <div className="dk-card-header">
                <h3>Zonder dakventilatie</h3>
                <div className="dk-efficiency-badge">Problematisch</div>
              </div>
              <div className="dk-stats">
                <div className="dk-stat">
                  <span className="dk-stat-value">€2.500</span>
                  <span className="dk-stat-label">Gemiddelde schade per jaar</span>
                </div>
                <div className="dk-stat">
                  <span className="dk-stat-value">80%</span>
                  <span className="dk-stat-label">Kans op vochtproblemen</span>
                </div>
                <div className="dk-stat">
                  <span className="dk-stat-value">10-15</span>
                  <span className="dk-stat-label">Jaren dak levensduur</span>
                </div>
              </div>
            </div>
            
            <div className="dk-comparison-card dk-wtw">
              <div className="dk-card-header">
                <h3>Met dakventilatie</h3>
                <div className="dk-efficiency-badge dk-efficient">Aanbevolen</div>
              </div>
              <div className="dk-stats">
                <div className="dk-stat">
                  <span className="dk-stat-value">€0</span>
                  <span className="dk-stat-label">Voorkomen schade</span>
                </div>
                <div className="dk-stat">
                  <span className="dk-stat-value">5%</span>
                  <span className="dk-stat-label">Kans op vochtproblemen</span>
                </div>
                <div className="dk-stat">
                  <span className="dk-stat-value">25-30</span>
                  <span className="dk-stat-label">Jaren dak levensduur</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ========== INSTALLATION PROCESS ========== */}
      <section className="dk-section" id="installatie">
        <div className="dk-container">
          <div className="dk-section-header">
            <h2 className="dk-section-title">Hoe werkt de installatie?</h2>
            <p className="dk-section-description">
              Van inspectie tot oplevering - professionele aanpak
            </p>
          </div>

          <div className="dk-process-flow">
            <div className="dk-process-step">
              <div className="dk-step-visual">
                <div className="dk-step-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L13.09 8.26L19 7L14.74 12L19 17L13.09 15.74L12 22L10.91 15.74L5 17L9.26 12L5 7L10.91 8.26L12 2Z" fill="currentColor"/>
                  </svg>
                </div>
              </div>
              <div className="dk-step-info">
                <h3>Gratis inspectie</h3>
                <p>We bekijken je dak en adviseren de beste ventilatie-oplossing</p>
                <div className="dk-step-duration">30 minuten</div>
              </div>
            </div>
            
            <div className="dk-process-step">
              <div className="dk-step-visual">
                <div className="dk-step-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" fill="currentColor"/>
                  </svg>
                </div>
              </div>
              <div className="dk-step-info">
                <h3>Offerte & planning</h3>
                <p>Duidelijke offerte met planning en materiaalkeuze</p>
                <div className="dk-step-duration">1-2 dagen</div>
              </div>
            </div>
            
            <div className="dk-process-step">
              <div className="dk-step-visual">
                <div className="dk-step-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" fill="currentColor"/>
                  </svg>
                </div>
              </div>
              <div className="dk-step-info">
                <h3>Installatie</h3>
                <p>Professionele installatie door ervaren monteurs</p>
                <div className="dk-step-duration">1-2 dagen</div>
              </div>
            </div>
            
            <div className="dk-process-step">
              <div className="dk-step-visual">
                <div className="dk-step-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/>
                  </svg>
                </div>
              </div>
              <div className="dk-step-info">
                <h3>Oplevering</h3>
                <p>Controle en uitleg over onderhoud en garantie</p>
                <div className="dk-step-duration">30 minuten</div>
              </div>
            </div>
          </div>

          <div className="dk-cta-row dk-cta-center">
            <a href="/offerte" className="cta-primary1" onClick={() => window.location.href = '/offerte'}>
              Gratis Inspectie
            </a>
            <a href="/tarieven" className="cta-secondary1 light" onClick={() => window.location.href = '/tarieven'}>
              Bekijk Tarieven
            </a>
          </div>
        </div>
      </section>

      {/* ========== FAQ ========== */}
      <section className="dk-section dk-section-light">
        <div className="dk-container">
          <div className="dk-section-header">
            <h2 className="dk-section-title">Veelgestelde vragen</h2>
            <p className="dk-section-description">
              Alles wat je moet weten over dakventilatie en installatie
            </p>
          </div>

          <div className="dk-faq-grid">
            {[
              {
                q: "Wanneer is dakventilatie nodig?",
                a: "Bij vochtproblemen, schimmelvorming, hoge energiekosten of als je dak isolatie heeft. We adviseren altijd bij nieuwbouw en renovatie.",
              },
              {
                q: "Welke ventilatie is het beste?",
                a: "Nokventilatie is meest populair (onzichtbaar), dakdoorvoeren voor platte daken, dakrandventilatie voor traditionele daken. We adviseren per situatie.",
              },
              {
                q: "Hoe lang duurt installatie?",
                a: "Meestal 1-2 dagen voor een gemiddeld dak. Complexere projecten kunnen 3-5 dagen duren. We werken netjes en stofvrij.",
              },
              {
                q: "Wat kost dakventilatie?",
                a: "Nokventilatie €150-200 per meter, dakdoorvoeren €200-300 per stuk, dakrandventilatie €100-150 per meter. Vaste prijzen, geen verrassingen.",
              },
              {
                q: "Hoe onderhoud ik dakventilatie?",
                a: "Jaarlijks controleren en reinigen. We bieden onderhoudscontracten voor optimale prestaties en langere levensduur van je dak.",
              },
            ].map((item, i) => (
              <div
                key={i}
                className={`dk-faq-card ${open === i ? "open" : ""}`}
                onClick={() => toggle(i)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => (e.key === "Enter" ? toggle(i) : null)}
              >
                <div className="dk-faq-question">
                  {item.q}
                  <span className="dk-faq-icon">{open === i ? "−" : "+"}</span>
                </div>
                {open === i && <div className="dk-faq-answer">{item.a}</div>}
              </div>
            ))}
          </div>
        </div>
      </section>

        </div>
    );
};

export default Dakventilatie;
